/**
 * KAN-882: какие кеши обновлять после правки клиента. Один набор на правку,
 * общий для карточки клиента, блока "Требуют внимания" и доски CRM
 * (useAssignClientManager, useSetClientLeadTemperature, useEditBoardCard).
 */
import type { QueryClient, QueryKey } from '@tanstack/react-query';
import { clientQueryKey } from './clientQueries';
import { ATTENTION_QUERY_KEY, LEAD_TEMPERATURE_QUERY_KEY, MANAGERS_QUERY_KEY } from './queryKeys';

/** После смены менеджера клиента: карточка, список клиентов, менеджеры, блок внимания (в нём доска CRM). */
export const clientManagerChangedKeys = (clientId: string): QueryKey[] => [
  clientQueryKey(clientId),
  ['clients'],
  MANAGERS_QUERY_KEY,
  ATTENTION_QUERY_KEY,
];

/** После смены теплоты клиента: карточка, раздел теплоты, блок внимания (в нём доска CRM). */
export const clientTemperatureChangedKeys = (clientId: string): QueryKey[] => [
  clientQueryKey(clientId),
  LEAD_TEMPERATURE_QUERY_KEY,
  ATTENTION_QUERY_KEY,
];

export function invalidateKeys(queryClient: QueryClient, keys: readonly QueryKey[]): Promise<void> {
  return Promise.all(keys.map((queryKey) => queryClient.invalidateQueries({ queryKey }))).then(() => undefined);
}
